import styled, { css } from 'styled-components';

export type StepContainerProps = {
  isStepSaveFailed: boolean;
  isHovered: boolean;
  isDragged: boolean;
};

const BORDER_RADIUS = '3px';
const BORDER_WIDTH = '2px';

// padding in combination with box sizing to avoid layout shift caused by appearing border
// padding-top is 1px to compensate the standard border-top of row
const BORDER_PLACEHOLDER_PADDING = css`
  box-sizing: border-box;
  padding: calc(${BORDER_WIDTH} - 1px) ${BORDER_WIDTH} ${BORDER_WIDTH};
`;

const FAILED_STYLE = css`
  background: var(
    --ds-background-accent-red-subtler,
    var(--ds-fb-background-accent-red-subtler)
  );
  border: ${BORDER_WIDTH} solid
    var(
      --ds-background-accent-red-subtle,
      var(--ds-fb-background-accent-red-subtle)
    ) !important;
  border-radius: ${BORDER_RADIUS};
  padding: 0;
`;

const DRAGGED_STYLE = css`
  background: var(
    --ds-background-accent-orange-subtler,
    var(--ds-fb-background-accent-orange-subtler)
  );
  border: ${BORDER_WIDTH} solid
    var(
      --ds-background-accent-orange-subtle,
      var(--ds-fb-background-accent-orange-subtle)
    ) !important;
  border-radius: ${BORDER_RADIUS};
  padding: 0;
`;

const HOVERED_STYLE = css`
  background: var(--ds-surface-hovered, var(--ds-fb-surface-hovered));
`;

const ContainerStyled = styled.div`
  display: flex;
  border-top: 1px solid var(--ds-border, var(--ds-fb-border));
  position: relative;

  ${BORDER_PLACEHOLDER_PADDING}
`;

/**
 * State priority: failed > dragged > focused > hovered
 */
export const StepContainerStyled = styled(ContainerStyled)<StepContainerProps>`
  ${({ isHovered, isDragged, isStepSaveFailed }) => {
    if (isStepSaveFailed) {
      return FAILED_STYLE;
    }

    if (isDragged) {
      return DRAGGED_STYLE;
    }

    if (isHovered) {
      return HOVERED_STYLE;
    }
  }};
`;

export const NewStepContainerStyled = styled(ContainerStyled)`
  padding: 0;
`;
